import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const feCompaniesApi = createAggrApiInstance(aggr.FrontendCompaniesApi)

export const fetchFECompanies = async (keyword: string, page: number) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesGetcompanies(keyword, page, 12))
  return res
}

export const fetchFECompanyTotalCount = async (keyword: string) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesGetcompanycount(keyword))
  return res
}

export const getOrganizationsByCompanyId = async (companyUuid: string) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesGetorganizations(companyUuid))
  return res
}

export const updateCompanyImage = async (companyUuid: string, file: File) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesUploadimage(companyUuid, file))
  return res
}

export const getCompanyPlanFeatures = async (companyUuid: string) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesGetfeatures(companyUuid))
  return res
}

export const queryCompanyPersonnelList = async (reqData: aggr.FECompanyQueryCompanyPersonnelListRq) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesQuerycompanypersonnellist(reqData))
  return res
}

export const sendOrganizationRegistrationInvitation = async (
  reqData: aggr.FECompanyOrganizationSendRegistrationInvitationRq
) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesSendorganizationregistrationinvitation(reqData))
  return res
}

export const queryOrganizationMembers = async (reqData: aggr.FECompanyOrganizationQueryMembersRq) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesQueryorganizationmembers(reqData))
  return res
}

export const queryOrganizationTags = async (reqData: aggr.FECompanyQueryOrganizationTagsRq) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesQueryorganizationtags(reqData))
  return res
}

/** 查詢可訪問公司和組織清單 */
export const getCompaniesAndOrganizations = async (term?: string) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesGetcompaniesandorganizations(term))
  return res
}

/** 新增或更新組織標籤（多筆） */
export const createOrUpdateOrganizationTags = async (reqData: aggr.FECompanyCreateOrUpdateOrganizationTagsRq) => {
  const res = await handleApiStatus(() => feCompaniesApi.companiesCreateorupdateorganizationtags(reqData))
  return res
}
